const modal = document.getElementById("roomModal");
const body = document.querySelector('body');

let generatedImageUrl = null;
let uploadedFile = null;
let featuredImageUrl = null;
let matchedThumbnailSrc = null;

async function urlToFile(url, filename) {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], filename, { type: blob.type });
}

document.addEventListener("click", function (e) {
    if (e.target.closest("#openRoomModal")) {
        resetModalState();
        document.getElementById("roomModal").style.display = "flex";
        document.body.classList.add('overflow-hidden');
        return;
    }

    if (e.target.closest("#closeRoomModal")) {
        resetModalState();
        document.getElementById("roomModal").style.display = "none";
        document.body.classList.remove('overflow-hidden');
        return;
    }

    // if (e.target.closest("#goProduct")) {
    //     resetModalState();
    //     document.getElementById("roomModal").style.display = "none";
    //     document.body.classList.remove('overflow-hidden');
    //     return;
    // }

    const modal = document.getElementById("roomModal");
    if (modal && e.target === modal) {
        modal.style.display = "none";
        document.body.classList.remove('overflow-hidden');
        return;
    }

    //  Variant image click
    if (e.target.closest(".variant-image")) {
        const item = e.target.closest(".variant-image");
        document.querySelectorAll(".variant-image").forEach(el => el.classList.remove("active"));
        item.classList.add("active");

        var selectedColor = item.dataset.title;
        console.log("Clicked Variant:", selectedColor);

        $('.product-gallery--viewer figure').each(function () {
            const alt = $(this).find('img').attr('alt');
            if (alt?.toLowerCase().includes(selectedColor.toLowerCase())) {
                matchedThumbnailSrc = $(this).find('img').attr('src');
                return false;
            }
        });

        featuredImageUrl = matchedThumbnailSrc;

        if (featuredImageUrl && featuredImageUrl.startsWith("//")) {
            featuredImageUrl = "https:" + featuredImageUrl;
        }

        if (uploadedFile) {
            sendImageToAPI(uploadedFile, featuredImageUrl);
        }
        return;
    }

    if (e.target.closest("#downloadResult")) {
        if (!generatedImageUrl) { alert("No image to download"); return; }
        const a = document.createElement("a");
        a.href = generatedImageUrl;
        a.download = "easyblinds-result.jpg";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        return;
    }

    if (e.target.closest("#share")) {
        handleShare();
        return;
    }
});

document.addEventListener("change", function (e) {
    if (e.target && e.target.id === "roomImage") {
        if (e.target.files && e.target.files.length) {
            uploadedFile = e.target.files[0];
            sendImageToAPI(uploadedFile, featuredImageUrl);
        }
    }
});

async function handleShare() {
    if (!generatedImageUrl) { alert("No image to share"); return; }
    const blob = await fetch(generatedImageUrl).then(r => r.blob());
    const file = new File([blob], "easyblinds-result.jpg", { type: blob.type });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
            title: "My EasyBlinds Preview",
            text: "Check out how these blinds look in my room!",
            files: [file]
        });
    } else {
        alert("Sharing not supported on this device");
    }
}

function resetModalState() {
    const aiResult = document.getElementById("aiResult");
    const uploadBody = document.getElementById("upload-body");
    const aiGenerating = document.getElementById("aiGenerating");
    const resultImage = document.getElementById("resultImage");

    if (!aiResult || !uploadBody || !aiGenerating || !resultImage) return;

    aiResult.classList.add("hidden");
    uploadBody.classList.remove("hidden");
    aiGenerating.classList.add("hidden");

    if (generatedImageUrl) {
        URL.revokeObjectURL(generatedImageUrl);
        generatedImageUrl = null;
    }
    resultImage.src = "";

    resetFileInput();

    document.querySelectorAll(".variant-image").forEach(el => el.classList.remove("active"));

    const firstVariantDiv = document.querySelector(".variant-image");
    if (firstVariantDiv) {
        firstVariantDiv.classList.add("active");

        var selectedColor = firstVariantDiv.dataset.title;
        console.log("Clicked Variant:", selectedColor);

        $('.product-gallery--viewer figure').each(function () {
            const alt = $(this).find('img').attr('alt');
            if (alt?.toLowerCase().includes(selectedColor.toLowerCase())) {
                matchedThumbnailSrc = $(this).find('img').attr('src');
                return false;
            }
        });

        featuredImageUrl = matchedThumbnailSrc;
    }

    if (featuredImageUrl && featuredImageUrl.startsWith("//")) {
        featuredImageUrl = "https:" + featuredImageUrl;
    }

    const swatchContainer = document.querySelector(".ai-modal-image-swatches");
    if (swatchContainer) {
        setTimeout(() => {
            swatchContainer.scrollTo({ top: 0, behavior: "smooth" });
        }, 1500);
    }
}

async function sendImageToAPI(file, featuredImageUrl, retryCount = 0) {
    const MAX_RETRIES = 3;
    const RETRY_DELAY = 2000; // 2 seconds between retries

    if (!file) { alert("Please upload a window image."); return; }
    if (!featuredImageUrl || featuredImageUrl.trim() === "") { alert("Please select a blinds image."); return; }

    const aiGenerating = document.getElementById("aiGenerating");
    const aiResult = document.getElementById("aiResult");
    const resultImage = document.getElementById("resultImage");
    const uploadBody = document.getElementById("upload-body");

    aiGenerating.classList.remove("hidden");
    aiResult.classList.add("hidden");

    const formData = new FormData();
    formData.append("window_file", file);
    formData.append("blinds_file", featuredImageUrl);

    try {
        const response = await fetch("https://php.easyblinds.com/api/generate-image.php", {
            method: "POST",
            body: formData
        });

        if (!response.ok) {
            let errorData = null;
            try { errorData = await response.json(); } catch (e) {}

            const is503 = errorData?.error?.code === 503 
                       || errorData?.error?.status === "UNAVAILABLE"
                       || response.status === 503;

      
            if (is503 && retryCount < MAX_RETRIES) {
                console.log(`Gemini busy, retrying... (${retryCount + 1}/${MAX_RETRIES})`);
                await new Promise(res => setTimeout(res, RETRY_DELAY));
                return sendImageToAPI(file, featuredImageUrl, retryCount + 1);
            }

            const errorMsg = is503
                ? "AI is currently busy — please try again in a moment."
                : (errorData?.detail || errorData?.error?.message || "Failed to generate image");

            resetFileInput();
            throw new Error(errorMsg);
        }

        const blob = await response.blob();
        generatedImageUrl = URL.createObjectURL(blob);

        aiGenerating.classList.add("hidden");
        resultImage.src = generatedImageUrl;
        aiResult.classList.remove("hidden");
        uploadBody.classList.add("hidden");
        resetFileInput();

    } catch (err) {
        aiGenerating.classList.add("hidden");
        alert(err.message || "Something went wrong");
        resetFileInput();
    }
}



function resetFileInput() {
    const roomInput = document.getElementById("roomImage");
    if (roomInput) roomInput.value = "";
}

